<template>
  <div class="banner">
    <Theme />
    <router-link :class="settingsActive ? 'active' : ''" to="/settings">
      <p v-if="!isPortrait">{{ companySettings.company_name }}</p>
      <font-awesome-icon icon="wrench" size="xl" />
    </router-link>
  </div>
  <div class="container">
    <Menu />
  </div>
  <div id="content"><slot /></div>
  <div v-if="loading" class="spinner">
    <LoadingSpinner :spinnerMessage="'Retrieving Data...'" />
  </div>
</template>

<script>
import { LoadingSpinner, Theme } from "@monolith/components";
import { mapGetters } from "vuex";
import Menu from "@/components/_layouts/Menu";
import { createdMixin } from "@monolith/mixins";

export default {
  components: {
    Menu,
    Theme,
    LoadingSpinner,
  },
  mixins: [createdMixin],
  name: "Authenticated",
  data() {
    return {
      isPortrait: window.matchMedia("(orientation: portrait)").matches,
    };
  },
  computed: {
    ...mapGetters({
      loading: "loading",
      companyName: "companyName",
      companySettings: "companySettings",
      getHours: "getHours"
    }),

    settingsActive() {
      let routeIsActive = false;
      const routes = ["/settings"];
      routes.forEach((route) => {
        if (this.$route.path.includes(route)) {
          routeIsActive = true;
        }
      });
      return routeIsActive;
    }
  },
  mounted() {
    this.$store.dispatch("loading");
    const portrait = window.matchMedia("(orientation: portrait)");
    portrait.onchange = (e) => (this.isPortrait = e.matches);
  },

  watch: {
    getHours() {
      if (this.getHours) {
        this.$hours.popHours(this.getHours)
      }
    }
  },
  
};
</script>

<style lang="scss">
.banner {
  position: fixed;
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  align-items: center;
  z-index: 100;
  width: 100%;
  background-color: var(--primary-colour);
  svg {
    padding: 0.5rem;
  }
  p {
    padding: 0.5rem;
  }
  a {
    display: flex;
    align-items: center;
  }
  .active {
    color: var(--action-colour) !important;
  }
  a.router-link-active {
    color: var(--action-colour) !important;
  }
}
.container {
  display: flex;
  top: 0;
  z-index: 100;
  margin: 3rem 0;
}
#content {
  flex: 1 0;
  margin: 0 0 0 5rem;
  position: relative;
  color: var(--text-colour);
}

.spinner {
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 1000;
  background-color: var(--opacity-background);
}

@media (orientation: portrait) {
  .container {
    width: 100%;
  }
  .banner {
    padding: 1rem 0;
    svg:last-child {
      padding-right: 1rem;
    }
  }
  #content {
    margin: auto;
    translate: none !important;
    overflow-y: scroll;
  }
  a.router-link-active {
    color: var(--action-colour);
  }
}
</style>
